import { NavDropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import { setLanguage } from "../actions/languageActions";
import { LANGUAGES } from "../i18n/translations";

/* Extracted out of the old single-row navbar — floats over the hero's
   banner/scrim (RestaurantHero.js), fixed white-on-dark chip regardless
   of the restaurant's chosen colors (see .language-switcher in
   RestaurantHero.css). */
function LanguageSwitcher() {
  const dispatch = useDispatch();
  const { language } = useSelector((state) => state.language);
  const activeLanguage = LANGUAGES.find((l) => l.code === language) || LANGUAGES[0];

  return (
    <NavDropdown
      title={
        <span className="language-switcher-title">
          {activeLanguage.flag} {activeLanguage.code.toUpperCase()}
        </span>
      }
      id="language-switcher"
      align="end"
      className="language-switcher no-caret"
    >
      {LANGUAGES.map((lang) => (
        <NavDropdown.Item
          key={lang.code}
          active={lang.code === language}
          onClick={() => dispatch(setLanguage(lang.code))}
        >
          {lang.flag} {lang.label}
        </NavDropdown.Item>
      ))}
    </NavDropdown>
  );
}

export default LanguageSwitcher;
